import { Component, Input, OnChanges } from '@angular/core';
import { QuestionBase, TagsQuestion } from 'core/components/forms';
import { UntypedFormControl } from '@angular/forms';
import { Client } from 'core/models/client';
import { TechTestService } from '../services/tech-test.service';
import { UtilsService, NotificationsService } from 'core/services';
import { StoreService } from 'core/services/store.service';
import { TechTestListService } from '../services/tech-test-list.service';

@Component({
  selector: 'lms-tech-test',
  templateUrl: './tech-test.component.html',
  styleUrls: ['./tech-test.component.scss'],
  providers: [TechTestListService]
})
export class TechTestComponent implements OnChanges {
  @Input() client: Client;
  public filters: any;
  public tests = [];
  public listId = 'CLIENTS_TECH_TEST_LIST';
  public listOptions: any;
  public dataSource: any;
  public toolbarConfig: any;
  questions: QuestionBase<any>[] = [];

  constructor(
    public techTestService: TechTestService,
    public notificationsService: NotificationsService,
    public techTestListService: TechTestListService
  ) {}

  ngOnInit() {
    this.toolbarConfig = {
      list: {
        listId: this.listId,
        download: false,
        filterRow: false,
        columnChooser: false,
        skeletor: true
      }
    };
  }

  async ngOnChanges() {
    this.setQuestions();
    this.filters = { clientId: this.client.id };
    this.listOptions = { filters: this.filters };
    this.dataSource = await this.techTestListService.getDatasource(this.listId, this.listOptions);
  }

  setQuestions() {
    this.questions = [
      new TagsQuestion({
        key: 'emails',
        label: 'nouns.email',
        value: [],
        validators: {
          required: true,
          function: (control: UntypedFormControl) => {
            if (control.value && control.value.length) {
              return control.value.some((email) => !UtilsService.EMAIL_REGEXP.test(email)) ? { mail: true } : null;
            }
          }
        }
      })
    ];
  }

  createTests({ emails }) {
    if (emails && emails.length) {
      const notificationData = { client: this.client, emails };
      this.notificationsService.sendTechTestsNotification(notificationData);
    }
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }

  setCollection(collection) {
    this.tests = collection;
  }
}
